<!--------------------------------------------Updated Content-------------------------------------------->
<app-nav-menu></app-nav-menu>
<!--------------------------------------------Updated Content-------------------------------------------->
@if (NewLoaderEmirates) {
  <div class="loader" style="width: 100%; height: 105vh; position: fixed; background: #000000e8; z-index: 4000; margin-top: 0px; top: 0px ">
    <div style=" display: flex; justify-content: center; align-items: center; height:100%">
      <svg class="svg-calLoader cal-loader__plane" xmlns="http://www.w3.org/2000/svg" width="230" height="230"><path class="cal-loader__path" d="M86.429 40c63.616-20.04 101.511 25.08 107.265 61.93 6.487 41.54-18.593 76.99-50.6 87.643-59.46 19.791-101.262-23.577-107.142-62.616C29.398 83.441 59.945 48.343 86.43 40z" fill="none" stroke="#0099cc" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="10 10 10 10 10 10 10 432" stroke-dashoffset="77" /><path class="cal-loader__plane" d="M141.493 37.93c-1.087-.927-2.942-2.002-4.32-2.501-2.259-.824-3.252-.955-9.293-1.172-4.017-.146-5.197-.23-5.47-.37-.766-.407-1.526-1.448-7.114-9.773-4.8-7.145-5.344-7.914-6.327-8.976-1.214-1.306-1.396-1.378-3.79-1.473-1.036-.04-2-.043-2.153-.002-.353.1-.87.586-1 .952-.139.399-.076.71.431 2.22.241.72 1.029 3.386 1.742 5.918 1.644 5.844 2.378 8.343 2.863 9.705.206.601.33 1.1.275 1.125-.24.097-10.56 1.066-11.014 1.032a3.532 3.532 0 0 1-1.002-.276l-.487-.246-2.044-2.613c-2.234-2.87-2.228-2.864-3.35-3.309-.717-.287-2.82-.386-3.276-.163-.457.237-.727.644-.737 1.152-.018.39.167.805 1.916 4.373 1.06 2.166 1.964 4.083 1.998 4.27.04.179.004.521-.076.75-.093.228-1.109 2.064-2.269 4.088-1.921 3.34-2.11 3.711-2.123 4.107-.008.25.061.557.168.725.328.512.72.644 1.966.676 1.32.029 2.352-.236 3.05-.762.222-.171 1.275-1.313 2.412-2.611 1.918-2.185 2.048-2.32 2.45-2.505.241-.111.601-.232.82-.271.267-.058 2.213.201 5.912.8 3.036.48 5.525.894 5.518.914 0 .026-.121.306-.27.638-.54 1.198-1.515 3.842-3.35 9.021-1.029 2.913-2.107 5.897-2.4 6.62-.703 1.748-.725 1.833-.594 2.286.137.46.45.833.872 1.012.41.177 3.823.24 4.37.085.852-.25 1.44-.688 2.312-1.724 1.166-1.39 3.169-3.948 6.771-8.661 5.8-7.583 6.561-8.49 7.387-8.702.233-.065 2.828-.056 5.784.011 5.827.138 6.64.09 8.62-.5 2.24-.67 4.035-1.65 5.517-3.016 1.136-1.054 1.135-1.014.207-1.962-.357-.38-.767-.777-.902-.893z" fill="#000033" /></svg>
    </div>
  </div>
}

<div style="padding:20px 20px">
  <div style="margin-bottom: 100px; padding-bottom: 0;display:flex;flex-direction:column;width:100%">
    <div style=" width: 100%;text-align:center">
      <h1 style=" font-size: 3rem; font-family: Varela Round, sans-serif;">Modify TravelPort Booking</h1>
    </div>
    <div style="width:100%;display:flex;gap:1%">
      <div style="width:20%">
        <div style=" border-top: 1px solid #d8d8d8; border-bottom: 1px solid #d8d8d8; ">

          <ul class="navbars">
            @if (changeBooking) {
              <li [class.active]="changeBooking" class="nav-itemf">
                <a>Change a Booking</a>
              </li>
            }
            @if (passengerDetails) {
              <li [class.active]="passengerDetails" class="nav-itemf"><a>Passenger Details</a></li>
            }


          </ul>

        </div>
      </div>
      <div style="width:79%">

        @if (changeBooking) {
          <div style="width:100%;display:flex;flex-direction:column;">
            <div style=" width: 100%;">
              <h1 style=" font-size: 1rem; font-family: Varela Round, sans-serif;">Change Penalty</h1>
            </div>
            <div style="width:100%">
              <div class="block">
                <h4>By Passenger Penalties</h4>
              </div>
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Passenger Name</th>
                    <th scope="col">Maximum Charge</th>
                    <th scope="col">Minimum Charge</th>
                  </tr>
                </thead>
                <tbody>
                  @for (passenger of exchangeEligibility.passengerList; track passenger; let p = $index) {
                    <tr>
                      <td>{{passenger.passengerName}}</td>
                      <td>{{passenger.currencyCode}} {{passenger.maximumPenaltyChange * exchangeEligibility.currencyRate}}</td>
                      <td>{{passenger.currencyCode}} {{passenger.minimumPenaltyChange  * exchangeEligibility.currencyRate}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            <div style=" width: 100%;">
              <h1 style=" font-size: 1rem; font-family: Varela Round, sans-serif;">Change Booking For Specific Sector or All</h1>
            </div>
            <div style="width:100%">
              <div class="block">
                <h4>Select Options to move forward to change the booking.</h4>
                @if (optionchangeforsomepass) {
                  <div style="text-align:right">
                    <p-select [options]="optionlist" [(ngModel)]="selectoption" (onChange)="onOptionChange()" placeholder="Select Options" optionLabel="name" name="optionv" optionValue="code"></p-select>
                  </div>
                }
                @if (somesector) {
                  <div>
                    @for (sector of bookingInfo.galileoBookingProp.flightProp.flightLocationInfo; track sector; let i = $index) {
                      <div>
                        <div class="inputGroup" style="width:70%">
                          <input id="option1{{i}}" [disabled]="aLLsector" [(ngModel)]="sector.modifyDeparture" name="option1{{i}}" type="checkbox" />
                          <label for="option1{{i}}">
                            <span style="width:100%;display:flex;">
                              <span style=" margin-left:15%;width: 43%; display: flex"> {{sector.fromCity}} <i class="fas fa-plane-departure mr-2 ml-2"></i> {{sector.toCity}}</span>
                              <!--<span style="margin-left: 40px; width: 20%; display: flex; flex-direction: column;">
                              <span style="font-size:6px">
                                Status
                              </span>
                              <span style="font-size:10px" *ngIf="!passenger.isDeleted">
                                Active
                              </span>
                              <span style="font-size:10px;" *ngIf="passenger.isDeleted">
                                Removed
                              </span>
                            </span>-->
                          </span>
                        </label>
                        <span class="optionafterinput"></span>
                      </div>
                    </div>
                  }
                </div>
              }
              <div style="padding:26px 6px 2px 6px;width:100%;display:flex;">
                <div style=" width:50%">
                  <span id="selectatleastoneremove" style="color:red;font-size:12px;"></span>
                </div>
                <div style="width:50%;text-align:right">
                  @if (buttonsshow) {
                    <button class="button-remove" (click)="modifyClick()">Modify</button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      @if (changeBookingNotAvail) {
        <div>
          <div style=" width: 100%;">
            <h1 style=" font-size: 1rem; font-family: Varela Round, sans-serif;">Change Booking is Not Available, Exchange must be processed manually by this airline.</h1>
          </div>
        </div>
      }

      @if (passengerDetails) {
        <div style="width:100%;display:flex;flex-direction:column;">
          <div style=" width: 100%;">
            <h1 style=" font-size: 1rem; font-family: Varela Round, sans-serif;">Passenger Details</h1>
          </div>
          <div style=" width: 100%;">
            <h1 style=" font-size: 1rem; font-family: Varela Round, sans-serif;">Update or ADD Passenger Details</h1>
          </div>
          <div style="width:100%">
            <div class="block">
              <h4>Select passenger to move forward to Add/Update the Details.</h4>
              <form>
                <div>
                  @for (passenger of bookingModifyProp.bookingPassengerInfoProperties; track passenger; let i = $index) {
                    <div>
                      <div class="inputGroup" style="width:70%">
                        <input id="option1{{i}}" [(ngModel)]="passenger.selectToModify" name="option1{{i}}" type="checkbox" />
                        <label for="option1{{i}}">
                          <span style="width:100%;display:flex;">
                            <span style=" margin-left:15%;width: 43%; display: flex"> {{passenger.firstName}}  {{passenger.lastName}}</span>
                          </span>
                        </label>
                        <span class="optionafterinput"></span>
                      </div>
                      @if (passenger.selectToModify) {
                        <div>
                          <div style="display: flex; flex-direction: column; width: 100%; gap: 7px; padding-bottom: 9px;">
                            <div class="checkbox-wrapper-46">
                              <input class="inp-cbx" id="emailCheck{{i}}" type="checkbox" [(ngModel)]="passenger.emailCheck" name="emailcheck{{i}}" />
                              <label class="cbx" for="emailCheck{{i}}">
                                <span>
                                  <svg width="12px" height="10px" viewbox="0 0 12 10">
                                    <polyline points="1.5 6 4.5 9 10.5 1"> </polyline>
                                  </svg>
                                  </span> <span> Email</span>
                                </label>
                              </div>
                              <div class="row m-0 justify-content-end pr-4">
                                @if (passenger.emailOneGProperties.addAble) {
                                  <button type="button" class="addnewbtn" (click)="AddAirline()">
                                    <i class="fas fa-plus-circle"></i> Add Email
                                  </button>
                                }
                              </div>
                              <div class="row m-0">
                                @for (eml of passenger.emailOneGProperties.emailList; track eml; let e = $index) {
                                  <div class="col-lg-4 ">
                                    <label class="labelofinputs">Email-{{e}}</label>
                                    <input type="text" class="inputStyle" [(ngModel)]="eml.email" name="email{{i}}{{e}}"  />
                                  </div>
                                }
                              </div>
                            </div>
                            <div style="display: flex; flex-direction: column; width: 100%; gap: 7px; padding-bottom: 9px;">
                              <div class="checkbox-wrapper-46">
                                <input class="inp-cbx" id="telephoneCheck{{i}}" type="checkbox" [(ngModel)]="passenger.telephoneCheck" name="telephonecheck{{i}}" />
                                <label class="cbx" for="telephoneCheck{{i}}">
                                  <span>
                                    <svg width="12px" height="10px" viewbox="0 0 12 10">
                                      <polyline points="1.5 6 4.5 9 10.5 1"> </polyline>
                                    </svg>
                                    </span> <span> Telephone</span>
                                  </label>
                                </div>
                                <div class="row m-0 justify-content-end pr-4">
                                  @if (passenger.telephoneOneGProperties.addAble) {
                                    <button type="button" class="addnewbtn" (click)="AddAirline()">
                                      <i class="fas fa-plus-circle"></i> Add Telephone
                                    </button>
                                  }
                                </div>
                                <div style="display: flex; flex-direction: column; width: 100%; gap: 7px; padding-bottom: 9px; width: 100%" >
                                  @for (tel of passenger.telephoneOneGProperties.telephone; track tel; let t = $index) {
                                    <div style="width:50%;margin-left:2%">
                                      <div style="width:100%">
                                        <span>Telephone - {{t+1}}</span>
                                      </div>
                                      <div style="width:100%;display:flex;gap:2%">
                                        <div style="width:19%;">
                                          <label class="labelofinputs">Country Code</label>
                                          <input type="text" class="inputStyle" [(ngModel)]="tel.countryAccessCode" name="countryAccessCode{{i}}{{t}}"  />
                                        </div>
                                        <div style="width:22%;">
                                          <label class="labelofinputs">Area Code</label>
                                          <input type="text" class="inputStyle" [(ngModel)]="tel.areaCityCode" name="areaCityCode{{i}}{{t}}"  />
                                        </div>
                                        <div style="width:45%;">
                                          <label class="labelofinputs">Phone Number</label>
                                          <input type="text" class="inputStyle" [(ngModel)]="tel.phoneNumber" name="phoneNumber{{i}}{{t}}"  />
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>
                              <div style="display: flex; flex-direction: column; width: 100%; gap: 7px; padding-bottom: 9px;">
                                <div class="checkbox-wrapper-46">
                                  <input class="inp-cbx" id="travelDocumentCheck{{i}}" type="checkbox" [(ngModel)]="passenger.travelDocumentCheck" name="traveldoccheck{{i}}" />
                                  <label class="cbx" for="travelDocumentCheck{{i}}">
                                    <span>
                                      <svg width="12px" height="10px" viewbox="0 0 12 10">
                                        <polyline points="1.5 6 4.5 9 10.5 1"> </polyline>
                                      </svg>
                                      </span> <span> Travel Documents</span>
                                    </label>
                                  </div>
                                  <div style="display: flex; flex-direction: column; width: 100%; gap: 7px; padding-bottom: 9px;">
                                    <div class=" row m-0">
                                      <div class="col-lg-4">
                                        <label class="labelofinputs">Passport Number</label>
                                        <input type="text" class="inputStyle" name="passportNumber{{i}}" [(ngModel)]="passenger.travelDocumentOneGProperties.travelerDocument.passportNumber"  />
                                      </div>
                                      <div class="col-lg-4">
                                        <label class="labelofinputs">Passport Expiry Date</label>
                                        <input type="date" class="inputStyle" [(ngModel)]="passenger.travelDocumentOneGProperties.travelerDocument.passportExpiryDate" name="passportExpiryDate{{i}}"  />
                                      </div>
                                      <div class="col-lg-4">
                                        <label class="labelofinputs">Passport Issuance Date</label>
                                        <input type="date" class="inputStyle" [(ngModel)]="passenger.travelDocumentOneGProperties.travelerDocument.passportIssuanceDate" name="passportIssuanceDate{{i}}"  />
                                      </div>
                                      <div class="col-lg-4">
                                        <label class="labelofinputs">Issuance Country</label>
                                        <input type="text" class="inputStyle" [(ngModel)]="passenger.travelDocumentOneGProperties.travelerDocument.issuanceCountry" name="issuanceCountry{{i}}"  />
                                      </div>
                                      <div class="col-lg-4">
                                        <label class="labelofinputs">Gender</label>
                                        <input type="text" class="inputStyle" [(ngModel)]="passenger.travelDocumentOneGProperties.travelerDocument.gender" name="gender{{i}}"  />
                                      </div>
                                      <div class="col-lg-4">
                                        <label class="labelofinputs">Nationality</label>
                                        <input type="text" class="inputStyle" [(ngModel)]="passenger.travelDocumentOneGProperties.travelerDocument.nationality" name="nationality{{i}}"  />
                                      </div>
                                      <div class="col-lg-4">
                                        <label class="labelofinputs">Birth Date</label>
                                        <input type="date" class="inputStyle" [(ngModel)]="passenger.travelDocumentOneGProperties.travelerDocument.birthDate" name="birthDate{{i}}"  />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div style="display: flex; flex-direction: column; width: 100%; gap: 7px; padding-bottom: 9px;">
                                  <div class="checkbox-wrapper-46">
                                    <input class="inp-cbx" id="loyaltyPointsChecked{{i}}" type="checkbox" [(ngModel)]="passenger.loyaltyPointsChecked" name="loyaltyPointsChecked{{i}}" />
                                    <label class="cbx" for="loyaltyPointsChecked{{i}}">
                                      <span>
                                        <svg width="12px" height="10px" viewbox="0 0 12 10">
                                          <polyline points="1.5 6 4.5 9 10.5 1"> </polyline>
                                        </svg>
                                        </span> <span> Customer Loyalty</span>
                                      </label>
                                    </div>
                                    <div class="row m-0">
                                      <div class="col-lg-4">
                                        <label class="labelofinputs">Frequent Flyer No</label>
                                        <input type="text" class="inputStyle" [(ngModel)]="passenger.customerLoyaltyPointsOneGProperties.loyaltyPoints" name="loyaltyPoints{{i}}"  />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                        </div>
                        <div style="padding:26px 6px 2px 6px;width:100%;display:flex;">
                          <div style=" width:50%">
                            <span id="selectatleastoneremove" style="color:red;font-size:12px;"></span>
                          </div>
                          <div style="width:50%;text-align:right">
                            <button  class="button-remove" (click)="modifyUpdateDetailsClick()">Modify</button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              }

            </div>
          </div>

        </div>
      </div>
      <p-toast></p-toast>
      <p-confirmDialog>
        <ng-template pTemplate="message" let-message>
          <div class="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border">
            <i class="pi pi-exclamation-circle text-6xl text-primary-500"></i>
            <p>{{ message.message }}</p>
          </div>
        </ng-template>
      </p-confirmDialog>


